// shared/services/api/cep.api.ts

import axios from "axios";

import { IEnderecoLoja } from "shared/interfaces/IEnderecoLoja";

/* ===================================
   LIMPAR CEP
=================================== */

function limparCep(
  cep:string
):string{

  return cep.replace(
    /\D/g,
    ""
  );
}

/* ===================================
   BUSCAR CEP
=================================== */

export async function buscarEnderecoPorCep(
  cep:string
):Promise<IEnderecoLoja | null>{

  const cleanCep=
    limparCep(cep);

  if(cleanCep.length !== 8){

    console.warn(
      "CEP inválido:",
      cep
    );

    return null;
  }

  try{

    const response=
      await axios.get(
        `https://viacep.com.br/ws/${cleanCep}/json/`
      );

    const data=
      response.data;

    if(data.erro){

      console.warn(
        "CEP não encontrado:",
        cep
      );

      return null;
    }

    return {
      cep:cleanCep,
      rua:data.logradouro || "",
      bairro:data.bairro || "",
      cidade:data.localidade || "",
      estado:data.uf || "",
    };

  }catch(error){

    console.error(
      "Erro ao buscar CEP:",
      error
    );

    return null;
  }
}